import React, { useState } from "react";
import { Button, Card, CardHeader, CardBody, Col, Row } from "reactstrap";
import { useGetCompanies } from "hooks";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";
import { cnpj, cpf } from "utils/mask";
import { DeleteModal, CenteredSpinner } from "components";

const CompanyList = ({ history }) => {
  const { SearchBar } = Search;
  const [modalItem, setModalItem] = useState(undefined);
  const [count, setCount] = useState(0);
  const { loadingCompanies, companies } = useGetCompanies(count);

  const columns = [
    {
      sort: true,
      dataField: "name",
      text: "Nome",
    },
    {
      sort: true,
      dataField: "cpf",
      text: "CPF",
      formatter: (cell, row) => (cell ? cpf(cell) : "-"),
    },
    {
      sort: true,
      dataField: "cnpj",
      text: "CNPJ",
      formatter: (cell, row) => (cell ? cnpj(cell) : "-"),
    },
    {
      sort: true,
      dataField: "city",
      text: "Cidade",
      formatter: (cell, row) => {
        return `${cell}, ${row.state.value}`;
      },
    },
    {
      isDummyField: true,
      dataField: "",
      text: "Ações",
      headerAlign: "right",
      formatter: (cell, row) => {
        return (
          <p className="text-right">
            <i
              className="icon-note action-button"
              onClick={() => {
                history.push({
                  pathname: "./empresas/detalhes",
                  state: { row },
                });
              }}
            />
            <i
              className="icon-trash ml-2 action-button"
              onClick={() => {
                setModalItem(row);
              }}
            />
          </p>
        );
      },
    },
  ];

  const pagination = paginationFactory({
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
  });

  const defaultSorted = [
    {
      dataField: "name",
      order: "asc",
    },
  ];

  return (
    <>
      <DeleteModal
        closeModal={() => setModalItem(undefined)}
        path="companies"
        type="company"
        modalItem={modalItem}
        refreshList={() => setCount(count + 1)}
      />
      <div className="animated">
        <Card>
          <CardHeader>Empresas</CardHeader>
          <CardBody>
            <Row>
              <Col>
                <ToolkitProvider
                  keyField="id"
                  data={companies}
                  columns={columns}
                  search
                >
                  {(props) => (
                    <>
                      <Row>
                        <Col sm={9}>
                          <SearchBar
                            {...props.searchProps}
                            placeholder="Buscar na tabela"
                            style={{ width: "100%" }}
                          />
                        </Col>
                        <Col sm={3} className="mb-3">
                          <Button
                            block
                            color="success"
                            onClick={() => {
                              history.push("./empresas/detalhes");
                            }}
                          >
                            Nova Empresa
                          </Button>
                        </Col>
                      </Row>

                      <Row className="mt-4">
                        {loadingCompanies ? (
                          <CenteredSpinner />
                        ) : (
                          <Col>
                            <BootstrapTable
                              {...props.baseProps}
                              bordered={false}
                              hover
                              pagination={pagination}
                              defaultSorted={defaultSorted}
                            />
                          </Col>
                        )}
                      </Row>
                    </>
                  )}
                </ToolkitProvider>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
    </>
  );
};

export default CompanyList;
